import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {CheckBox} from '../booleanInputs/checkBox';

/*
 * Props.
 */

interface DropdownItemCheckboxProps {
  /** Should the input be checked. */
  isChecked?: boolean;
  /** Should interactions with the input be allowed. */
  isDisabled?: boolean;
  /** Whether to remove left margin. This is used for P1 auto-recommendations. */
  shouldRemoveLeftMargin?: boolean;
}

interface DropdownItemStyleProps {
  $shouldRemoveLeftMargin?: boolean;
}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div<DropdownItemStyleProps>`
  grid-area: right-icon;
  align-self: center;

  ${(p) => maybeAddRarelyViewedBadgeStyles(p)}
`;

function maybeAddRarelyViewedBadgeStyles(p: DropdownItemStyleProps) {
  if (p.$shouldRemoveLeftMargin) {
    return '';
  }
  return css`
    margin-left: 8px;
  `;
}

/*
 * Component.
 */

export const DropdownItemCheckbox: FC<DropdownItemCheckboxProps> = (props) => (
  <StyledWrapperDiv $shouldRemoveLeftMargin={props.shouldRemoveLeftMargin}>
    <CheckBox
      {...props}
      onChange={() => {
        /*
        `onChange` is a no-op, as the DropdownItem parent's onSelect
        should handle clicks instead.
        */
      }}
    />
  </StyledWrapperDiv>
);
